import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
    GetCurrentVenueCustomPaymentMethodComponent,
    refetchGetCurrentVenueCustomPaymentMethodsQuery,
    useRemoveCustomPaymentMethodMutation,
    useUpdateCustomPaymentMethodMutation,
} from '../../../../generated/graphql';
import { EditFormLayout } from '../../../../ui-kit';
import { routePaths } from '../../../../routePaths';
import { sanitizeFormValues } from '../../../../utils';
import { LocationReferrer } from '../../../../types/locationReferrer';
import CustomPaymentMethodForm from './CustomPaymentMethodForm';
import { OnSubmit } from './types';

interface UpdateCustomPaymentMethodFormProps {
    customPaymentMethodId: string;
}

const refetchCustomPayments = refetchGetCurrentVenueCustomPaymentMethodsQuery({ onlyActive: false });

const UpdateCustomPaymentMethodForm = ({ customPaymentMethodId }: UpdateCustomPaymentMethodFormProps) => {
    const { t } = useTranslation();
    const history = useHistory<LocationReferrer>();
    const { state = {} } = history.location;
    const { referrer } = state;

    const [removeCustomPaymentMethod] = useRemoveCustomPaymentMethodMutation({
        refetchQueries: [refetchCustomPayments]
    });
    const [updateCustomPaymentMethod] = useUpdateCustomPaymentMethodMutation({
        refetchQueries: [refetchCustomPayments]
    });


    const onRemove = async () => {
        try {
            await removeCustomPaymentMethod({ variables: { id: customPaymentMethodId } });
            history.push(routePaths.customPaymentMethodsSettings);
        } catch (error) {
            console.error(error);
        }
    };

    const onSubmit: OnSubmit = async formValues => {
        const sanitizedFormValues = sanitizeFormValues(formValues);

        try {
            await updateCustomPaymentMethod({
                variables: {
                    data: sanitizedFormValues,
                    id: customPaymentMethodId,
                },
            });
            history.push(referrer || routePaths.customPaymentMethodsSettings);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <GetCurrentVenueCustomPaymentMethodComponent variables={{ id: customPaymentMethodId }}>
            {({ data: { currentVenueCustomPaymentMethod } }) => {
                const { isActive, name } = currentVenueCustomPaymentMethod;
                return (
                    <EditFormLayout
                        onRemove={onRemove}
                        title={t('Update payment method')}
                        buttonText={t('Remove')}
                    >
                        <CustomPaymentMethodForm submitText={t('Update')} onSubmit={onSubmit} initialValues={{ isActive, name }} />
                    </EditFormLayout>
                );
            }}
        </GetCurrentVenueCustomPaymentMethodComponent>
    );
};

export default UpdateCustomPaymentMethodForm;